import { Container } from '@/components/atoms';
import { DifferentiatorCard } from '@/components/molecules';
import { differentiators } from '@/data';

// Differentiators — 4 SVG-icon cards (frame 23:18).
export function Differentiators() {
  return (
    <section className="bg-night-blue py-14 text-white">
      <Container>
        <div className="mb-10 text-center">
          <h2 className="font-condensed text-3xl font-bold">Why DrBurns’ ReLeaf</h2>
          <p className="mt-2 text-white/60">What sets a physician-formulated line apart.</p>
        </div>
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {differentiators.map(d => (
            <div key={d.title} className="[&_h3]:text-white [&_p]:text-white/60">
              <DifferentiatorCard item={d} />
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
